import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";

import request from "../../utils/request";
import requestAi from "../../utils/request-ai";

// Create entity adapter
const postsAdapter = createEntityAdapter();

const initialState = postsAdapter.getInitialState({
  isLoading: false,
  page: 0,
  error: null,
  post_form_data: {},
  pre_genertated_jds: [],
  custom_templates: [],
  totalPosts: 0,
  postsData: {},
});

// Async thunk for fetching all posts
export const getAllPosts = createAsyncThunk(
  "posts/getAllPosts",
  async (
    { page = 0, query = "", filter = "", take = 10, companyId },
    { getState, rejectWithValue }
  ) => {
    try {
      // const { auth } = getState();
      const { companies } = getState();
      // const company_id = auth.user?.company_id;
      // const company_id = companies.companies[0]?.id;
      const company_id = companyId;
      const payload = { company_id: company_id, skip: page, take, query };

      if (filter && filter !== "All")
        payload.job_status = filter?.toLowerCase();

      const response = await request({
        url: "/jobs/get-all",
        method: "POST",
        data: payload,
      });

      return {
        page,
        query,
        data: response.data?.data,
        count: response?.data?.count || 0,
      };
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for fetching all posts scheduled
export const getAllScheduledPosts = createAsyncThunk(
  "posts/getAllScheduledPosts",
  async (_, { getState, rejectWithValue }) => {
    try {
      // const { auth } = getState();
      // const company_id = auth.user?.company_id;
      const { companies } = getState();
      const company_id = companies.companies[0]?.id;
      const response = await request({
        url: "/jobs/scheduled",
        method: "GET",
        params: { company_id: company_id },
      });

      console.log("RESPONSE", response);

      return response.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for fetching all pe generated jds
export const getPreGeneratedJds = createAsyncThunk(
  "posts/getPreGeneratedJds",
  async (_, { getState, rejectWithValue }) => {
    try {
      const response = await request({
        url: "/jobs/generated_jds",
        method: "GET",
      });

      console.log("RESPONSE from generated_jds", response);

      return response.data;
    } catch (error) {
      console.log("Error in generated_jds", error);
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for getting a single post
export const getSinglePost = createAsyncThunk(
  "posts/getSingle",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/jobs/by-id`,
        method: "GET",
        params: { job_post_id: id },
      });

      return response.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for getting a create post
export const createPost = createAsyncThunk(
  "posts/createPost",
  async ({ data, cb }, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/jobs/create`,
        method: "POST",
        data: data,
      });

      enqueueSnackbar(response?.message, { variant: "success" });
      if (response?.statusCode === 200) {
        if (typeof cb === "function") {
          cb(response?.data);
        }
      }

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for invite candidate on job post
export const inviteCandidateOnJob = createAsyncThunk(
  "posts/inviteCandidateOnJob",
  async ({ data, cb }, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/jobs/invite-candidates`,
        method: "POST",
        data: data,
      });

      enqueueSnackbar(response?.message, { variant: "success" });
      if (response?.statusCode === 200) {
        if (typeof cb === "function") {
          cb(response?.data);
        }
      }

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for cancelling a scheduled post
export const cancelpost = createAsyncThunk(
  "posts/cancelpost",
  async ({ job_id, cb }, { rejectWithValue }) => {
    try {
      const response = await requestAi({
        url: `/delete_scheduled_post`,
        method: "POST",
        data: { job_id },
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      if (response?.message === "Post deleted successfully") {
        if (typeof cb === "function") {
          cb(); // Execute callback if provided
        }

        return { job_id }; // Return job_id for Redux update
      }

      return rejectWithValue("Post deletion failed");
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for cancelling a scheduled post
export const sharePostNowAiApi = createAsyncThunk(
  "posts/sharePostNowAiApi",
  async ({ data, repost, cb }, { rejectWithValue }) => {
    try {
      const { job_id } = data;
      const response = await requestAi({
        url: `/linkedin_post`,
        method: "POST",
        data,
      });

      // enqueueSnackbar(response?.message, { variant: "success" });

      if (response?.message === "Post submitted successfully") {
        if (typeof cb === "function") {
          console.log("enter here in callback");
          cb(); // Execute callback if provided
        }

        return { job_id, repost: repost ? repost : false }; // Return job_id for Redux update
      }

      return rejectWithValue("Post deletion failed");
    } catch (error) {
      console.log("error", error);
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for uploading custom template
export const uploadCustomTemplateApi = createAsyncThunk(
  "posts/uploadCustomTemplateApi",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await requestAi({
        url: `/get_template_image`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("response", response);

      return response?.url;
    } catch (error) {
      console.log("error", error);
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for get all custom templates
export const getPostTemplates = createAsyncThunk(
  "posts/getPostTemplates",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/jobs/get-post-templates`,
        method: "GET",
        params: { company_id: id },
      });

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for cancelling a scheduled post
export const togglePostActiveOrInActive = createAsyncThunk(
  "posts/togglePostActiveOrInActive",
  async ({ job_id, status, cb }, { rejectWithValue }) => {
    try {
      const response = await request({
        url: `/jobs/toggle-status`,
        method: "PUT",
        data: { id: job_id, job_status: status },
      });

      enqueueSnackbar(response?.message, { variant: "success" });

      if (typeof cb === "function") {
        cb(); // Execute callback if provided
      }

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Async thunk for getting a create post
export const updatePost = createAsyncThunk(
  "posts/updatePost",
  async ({ data, cb }, { rejectWithValue }) => {
    try {
      console.log("payload", data);

      const response = await request({
        url: `/jobs/update`,
        method: "PUT",
        data,
      });

      console.log("response", response);
      // enqueueSnackbar(response?.message, { variant: "success" });

      if (response?.statusCode === 200) {
        if (typeof cb === "function") {
          cb(response?.data);
        }
      }

      return response?.data;
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Slice
const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    clearPostFormData: (state) => {
      state.post_form_data = {};
    },
    updatePostFormData: (state, action) => {
      state.post_form_data = { ...state.post_form_data, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPosts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllPosts.fulfilled, (state, action) => {
        state.isLoading = false;

        state.totalPosts = action.payload.count;
        postsAdapter.upsertMany(state, action.payload.data || []);
        if (!action.payload.query) {
          state.postsData = {
            ...state.postsData,
            [action.payload.page]:
              action.payload.data?.length > 0
                ? action?.payload?.data?.map((d) => d?.id)
                : [],
          };
        } else {
          state.postsData = {
            [action.payload.page]:
              action.payload.data?.length > 0
                ? action?.payload?.data?.map((d) => d?.id)
                : [],
          };
        }
      })
      .addCase(getAllPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(getAllScheduledPosts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllScheduledPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        postsAdapter.setAll(state, action.payload);
      })
      .addCase(getAllScheduledPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(getSinglePost.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSinglePost.fulfilled, (state, action) => {
        state.isLoading = false;
        postsAdapter.upsertOne(state, action.payload);
      })
      .addCase(getSinglePost.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(createPost.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createPost.fulfilled, (state) => {
        state.isLoading = false;
        // postsAdapter.addOne(state, action.payload);
      })
      .addCase(createPost.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(togglePostActiveOrInActive.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(togglePostActiveOrInActive.fulfilled, (state, action) => {
        state.isLoading = false;
        postsAdapter.updateOne(state, {
          id: action.payload.id,
          changes: action.payload,
        });
      })
      .addCase(togglePostActiveOrInActive.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(updatePost.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePost.fulfilled, (state, action) => {
        state.isLoading = false;
        postsAdapter.updateOne(state, {
          id: action.payload.id,
          changes: action.payload,
        });
      })
      .addCase(updatePost.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(getPostTemplates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPostTemplates.fulfilled, (state, action) => {
        let templatesData =
          action.payload?.templates?.length > 0
            ? action.payload?.templates
            : [];
        state.isLoading = false;
        state.custom_templates = templatesData; //
      })
      .addCase(getPostTemplates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(uploadCustomTemplateApi.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(uploadCustomTemplateApi.fulfilled, (state, action) => {
        state.isLoading = false;
        const newTemplate = action.payload; // assuming this is a single template object

        if (newTemplate) {
          state.custom_templates.push(newTemplate); // append to existing array
        }
      })

      .addCase(uploadCustomTemplateApi.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })

      // Extra Reducer for getPreGeneratedJds
      .addCase(getPreGeneratedJds.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPreGeneratedJds.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pre_genertated_jds = action.payload; // Store pre-generated JDs
      })
      .addCase(getPreGeneratedJds.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      // Handle Post Deletion
      .addCase(cancelpost.fulfilled, (state, action) => {
        const { job_id } = action.payload;
        if (job_id) {
          postsAdapter.removeOne(state, job_id); // Remove the post from Redux state
        }
      })
      .addCase(sharePostNowAiApi.fulfilled, (state, action) => {
        const { job_id, repost } = action.payload;

        if (job_id && !repost) {
          postsAdapter.removeOne(state, job_id);
        }
      });
  },
});

// ACTION EXORT
export const {
  clearPostCreationStates,
  editPostContent,
  clearPostFormData,
  updatePostFormData,
} = postsSlice.actions;

// SELECTORS
export const {
  selectAll: selectAllPosts,
  selectById: selectPostById,
  selectIds: selectPostIds,
} = postsAdapter.getSelectors((state) => state.posts);

export const selectFlattenPostData = (state) => {
  return typeof state.posts.postsData === "object"
    ? Object.values(state.posts.postsData)?.flat()
    : [];
};
export const selectLoading = (state) => state.posts.isLoading;
export const selectPage = (state) => state.posts.page;
export const selectError = (state) => state.posts.error;

export default postsSlice.reducer;
